import React from 'react'
import './Card.css'

  
function Card({title,imageUrl,body}){
    return(
    <article className='card'>
            <picture className='thumbnail'>
                <img src={imageUrl} alt= ''/>
            </picture>
            <div className='card-content'>
                <h3>{title}</h3>
                <p>{body}</p>
            </div>
    </article>
    )
}


export default Card